import Toastify from "./Toastify";

export default Toastify;